"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledErrorMessage = exports.StyledCheckbox = exports.StyledLabel = exports.StyledCheckboxContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  font-size: ", ";\n  color: ", ";\n  padding: 0 0 0 1.9rem;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["background: url('data:image/svg+xml;utf8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" \n                                    width=\"26\" height=\"26\" viewBox=\"0 0 23 23\"%3E%3Cpath d=\"M0 0h24v24H0z\" \n                                    fill=\"none\"/%3E%3Cpath d=\"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\" \n                                    fill=\"", "\"/%3E%3C/svg%3E') no-repeat center center"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  -webkit-appearance: none;\n  height: 1.5em;\n  width: 1.5em;\n  position: relative;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  outline: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 0.5rem;\n\n  &:checked {\n    ", ";\n\n    background-size: auto;\n  }\n\n  &:disabled {\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var disabledStyle = function disabledStyle(props) {
  return (0, _styledComponents.css)(_templateObject(), props.disabled && "opacity: 0.3;");
};

var setAlignment = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};

var StyledCheckboxContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return setAlignment[props.align];
});

exports.StyledCheckboxContainer = StyledCheckboxContainer;

var StyledLabel = _styledComponents.default.label(_templateObject3(), function (props) {
  return props.disabled && disabledStyle;
});

exports.StyledLabel = StyledLabel;

var StyledCheckbox = _styledComponents.default.input.attrs({
  type: 'checkbox'
})(_templateObject4(), function (props) {
  return props.color;
}, function (props) {
  var color = props.color.startsWith('#') && props.color.replace('#', '%23') || props.color;
  return (0, _styledComponents.css)(_templateObject5(), color);
}, disabledStyle);

exports.StyledCheckbox = StyledCheckbox;

var StyledErrorMessage = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.theme.typography.text.small.fontSize.xs;
}, function (props) {
  return props.theme.colors.error300;
});

exports.StyledErrorMessage = StyledErrorMessage;